// src/components/forms/teamForms/editAvailability.js
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SubmitButton from '../formComponents/SubmitButton';
import ErrorMessage from '../formComponents/ErrorMessage';

export default function EditAvailabilityForm({
  initialAvailability,
  isOpen,
  onClose,
  onSave,
  allowLiveChange = true,
}) {
  const validOptions = ['Open', 'Closed', 'On Approval'];
  const availability = initialAvailability ?? {};

  const [live, setLive] = useState(!!availability.live);
  const [isPublic, setIsPublic] = useState(!!availability.public);
  const [joinable, setJoinable] = useState(
    validOptions.includes(availability.joinable)
      ? availability.joinable
      : 'Closed'
  );

  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await onSave({ live: allowLiveChange ? live : availability.live, public: isPublic, joinable });
    } catch (err) {
      setError(err.message || 'Failed to update availability');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <h2 className="modal-title">Edit Availability</h2>
      {error && <ErrorMessage message={error} />}

      <form onSubmit={handleSubmit} className="modal-form">
        <label>
          <input
            type="checkbox"
            checked={live}
            onChange={(e) => setLive(e.target.checked)}
            disabled={submitting || !allowLiveChange}
          />{' '}
          Team is live
        </label>

        <label>
          <input
            type="checkbox"
            checked={isPublic}
            onChange={(e) => setIsPublic(e.target.checked)}
            disabled={submitting}
          />{' '}
          Team is publicly visible
        </label>

        <label>
          Joinable status:
          <select
            value={joinable}
            onChange={(e) => setJoinable(e.target.value)}
            disabled={submitting}
          >
            <option value="Open">Open to anyone</option>
            <option value="Closed">Closed</option>
            <option value="On Approval">Join requests only</option>
          </select>
        </label>

        <div className="form-actions">
          <SubmitButton
            type="button"
            label="Cancel"
            onClick={onClose}
            disabled={submitting}
            variant="ghost"
            size="sm"
          />
          <SubmitButton
            type="submit"
            label={submitting ? 'Saving…' : 'Save'}
            disabled={submitting}
            variant="primary"
          />
        </div>
      </form>
    </>
  );
}

EditAvailabilityForm.propTypes = {
  initialAvailability: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};
